import { Button } from '@chakra-ui/react';
import DisplaySub from '../../../components/page-components/subscription/DisplaySub';

const Plans = ({ product, priceId, setPriceId }) => {
    return (
        <Button
            key={product.id}
            variant='outline'
            size='full'
            onClick={() => {
                setPriceId(product.priceId);
            }}
        >
            <DisplaySub
                subLoading={false}
                planName={product.name}
                features={product.features}
                priceAmount={product.priceAmount}
                showRadioButton={true}
                isSelected={priceId === product.priceId}
            />
        </Button>
    );
};

export default Plans;